import { render, staticRenderFns } from "./SliderCockpit.vue?vue&type=template&id=4ace53cb&scoped=true&"
import script from "./SliderCockpit.vue?vue&type=script&lang=js&"
export * from "./SliderCockpit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace53cb",
  null
  
)

export default component.exports